import axios from "axios";
import toast from "react-hot-toast";

const url = process.env.REACT_APP_API_BASE_URL;

let isLoggingOut = false;

export const handleLogout = async () => {
  if (isLoggingOut) return;
  isLoggingOut = true;
  toast.error("Session has expired. Log in to continue", { id: "session-expired" });
  localStorage.clear();
  window.location = "/#/login";
};
const axiosInstance = axios.create({
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const selectedOrg = localStorage.getItem("selectedOrg");
  const selectedCounty = localStorage.getItem("selectedCounty");

  config.params = {
    ...(config.params || {}),
    org_header: selectedOrg,
    county_header: selectedCounty,
  };

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    // console.log(response.headers);
    return response;
  },
  (error) => {
    const statusCode = error.response ? error.response.status : null;
    if (statusCode == 403) {
      // handleLogout();
    }
    if (statusCode == 401) {
      const message = error.response?.data?.message || "You do not have permission to access this resource";
      toast.error(message, { id: "unauthorized-401" }); 
      return Promise.resolve({ data: { success: false, data: { result: [] }, total: 0, _unauthorized: true } });
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
